(ns bp-clients.tv-app.utils.keycodes
  (:require [bp-clients.tv-app.utils.os :as os-system]))

(def previous-lg 461)
(def arrow-left 37)
(def arrow-up 38)
(def arrow-right 39)
(def arrow-down 40)
(def click 13)
(def fast-forward 417)
(def rewind 412)
(def play-pause 10252)
(def play-key 415)
(def stop-key 413)
(def pause-key 19)
(def previous 10009)
(def escape 27)
(def backspace 8)
(def space 32)
(def letterB 66) ;; used for testing

(def k->event-code
  {:up         (list arrow-up)
   :left       (list arrow-left rewind)
   :right      (list arrow-right fast-forward)
   :down       (list arrow-down)
   :ok         (list click)
   :ff         (list fast-forward arrow-right)
   :fr         (list rewind arrow-left)
   :play       (list play-key)
   :play-broad (list play-key play-pause space click)
   :pause      (list pause-key)
   :stop       (list stop-key)
   :play-pause (list play-pause space)
   :previous   (list previous previous-lg escape letterB backspace)})

(defn register-tizen-keys []
  (when (os-system/tizen?)
    (-> js/tizen .-tvinputdevice
        (.registerKey "MediaRewind"))
    (-> js/tizen .-tvinputdevice
        (.registerKey "MediaPlay"))
    (-> js/tizen .-tvinputdevice
        (.registerKey "MediaPause"))
    (-> js/tizen .-tvinputdevice
        (.registerKey "MediaStop"))
    (-> js/tizen .-tvinputdevice
        (.registerKey "MediaPlayPause"))
    (-> js/tizen .-tvinputdevice
        (.registerKey "MediaFastForward"))))

(defn ok? [key-code]
  (contains? (set (:ok k->event-code)) key-code))

(defn left? [key-code]
  (contains? (set (:left k->event-code)) key-code))

(defn right? [key-code]
  (contains? (set (:right k->event-code)) key-code))

(defn down? [key-code]
  (contains? (set (:down k->event-code)) key-code))

(defn up? [key-code]
  (contains? (set (:up k->event-code)) key-code))

(defn previous? [key-code]
  (contains? (set (:previous k->event-code)) key-code))

(defn play? [key-code]
  (contains? (set (:play k->event-code)) key-code))

(defn pause? [key-code]
  (contains? (set (:pause k->event-code)) key-code))

(defn play-pause? [key-code]
  (contains? (set (:play-pause k->event-code)) key-code))

(defn ff? [key-code]
  (contains? (set (:ff k->event-code)) key-code))

(defn fr? [key-code]
  (contains? (set (:fr k->event-code)) key-code))

(defn play-broad-sense? [key-code]
  (contains? (set (:play-broad k->event-code)) key-code))
